import createErrorHandler from 'utils/createErrorHandler';

export default function validateBlacklistPauseDates(
  pauseStartDate,
  pauseEndDate
) {
  const startDate = new Date(pauseStartDate);
  const endDate = new Date(pauseEndDate);
  const currentDate = new Date();
  currentDate.setHours(0, 0, 0, 0);
  const [errors, addError] = createErrorHandler();

  if (currentDate.getTime() >= startDate.getTime()) {
    addError('start_date', 'The "Pause From" date should be in future.');
    return errors;
  } else if (endDate <= startDate) {
    addError(
      'end_date',
      'The "Pause From" date should be less than the "Pause End" date.'
    );
    return errors;
  }
  return false;
}
